export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10889.4a4f2d00.jpg";